<template>

  <div class="landcovermap">
    <div class="row no-gutters" v-if="title">
      <div class="col text-left">
        <h4 style="margin-top:3px;">{{title}}</h4> 
      </div>
      <div class="col text-right" style="padding:9px 5px 0px 0px;">

        <ul class="cmd-group">
          <li class="title"><a href="#" @click.prevent="nextBackground">Units</a></li>
          <li v-for="unit in availableUnits">
            <a href="#" :class="{ active:selectedUnits == unit.name }" @click.prevent="selectedUnits=unit.name">{{ unit.label }}</a>
          </li>
        </ul>
        
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col"><hr style="margin:0px 0px;"/></div>
    </div>
    <div class="row no-gutters" style="padding-bottom:10px;">

      <div class="col col-12" style="padding:3px 10px;">
        <h5>Choose a data source: <a class="explainer-link" href="#" @click.prevent="explainerStart('summary_stats_indicators')" style="font-size:1.0em;"><i class="bi bi-question-circle"></i></a></h5>


        <form id="indicators">
        <div class="row no-gutters" style="background:none;">
            <template v-for="source in enabledSources">
              <div class="form-check" style="width:50%;">
                <input class="form-check-input" v-model="selectedSourceId" type="radio" :value="source.id" :id="'source-'+source.id" name="sources" checked>
                <label class="form-check-label" :for="'source-'+source.id">{{source.name}}</label>
              </div>
            </template>
        </div>
        </form>
      </div>

      <div class="col col-3" style="padding:3px 10px;border-left:1px solid #ddd;display:none;">
        <h5>Display results as:</h5>
        <div class="form-check" v-for="unit in availableUnits" style="font-size:0.75em;">
          <input class="form-check-input" type="radio" name="'landcover-'+unit.name" :id="'landcover-'+unit.name" :value="unit.name" v-model="selectedUnits">
          <label class="form-check-label" :for="'landcover-'+unit.name">
            {{ unit.label }}
          </label>
        </div>
      </div>

    </div>


    <div class="row no-gutters" style="">
      <div class="col">
        <hr style="margin-top:0px;margin-bottom:10px;"/>

      </div>
    </div>


    <div class="row no-gutters">

      <div class="col col-5">
        <div style="width:100%;height:450px;overflow-x:hidden;overflow-y:scroll;" id="results-scroll-container">
          <div style="color:#db6504;margin:0px 10px 5px 5px;padding:5px;font-size:0.65em;background-color:rgba(249, 115, 6, 0.05);border:1px solid rgba(249, 115, 6, 0.25);text-align:left;">
            <strong v-if="selectedSource && selectedSource['meta']['is_static'] == false">Tip: Click the classes below to explore changes.</strong>
            <strong v-if="selectedSource && selectedSource['meta']['is_static'] == true">The land cover data source "{{selectedSource['name']}}" contains data for only one point in time ({{selectedSource['epochs'][0]['name']}}). Unfortunately, analysing before/after changes and change trajectories is therefore not possible.</strong>
          </div>

          <ul id="result-list">


            <li v-for="(result, n) in results" class="result-item" :id="result.fid" :key="result.id">
                <a @click.prevent="toggleLandCover(result.id)" href="#" :class="{ selected: selectedLandCoverId == result.id }" :style="resultItemStyle">

                  <div style="float:left;font-size:1.2em;margin-left:0px;" title="item">

                    <div :style="landcoverStyle(result)"><div style="width:100%;height:100%;text-align:center;"></div></div>
                    
                  </div>


                  <div style="float:right;color:#666;" v-html="landcoverUnits(result)"></div>
                  
                  <div style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;max-width:250px;">



                  {{ result.description }}
                  </div>

                  
                  <LandCoverAnalysisDetails v-if="selectedLandCoverId == result.id" v-bind:item="result" v-bind:resultsLookup="resultsLookup" v-bind:source="selectedSource" changesOnly="false" />
                  
                  
                </a>

            </li>
          </ul>


        </div>

      </div>

      <div class="col col-7" style="max-height:450px;">
        <div ref="map" class="map" style="height:450px;"></div>

        <div style="width:100%;padding:0px;font-size:0.75em;position:relative;top:-100px;z-index:9999;height:100px;" v-if="selectedSource && (selectedSource['meta']['is_static'] == false) && (this.selectedLandCoverId == null)">
          <div style="width:100%;position:absolute;bottom:10px;padding:0px 10px;">
            <table style="width:100%;text-align:center;border:1px solid #ccc;position:relative;background-color:rgba(250,250,250,0.8);">
              <tr>
                <td style="width:0%;text-align:right;padding-right:10px;padding-left:10px;border-right:1px solid #ccc;"><a title="Download land cover as GeoTIFF" :href="downloadUrlStart" target="_blank" style="color:#ccc;"><i class="fas fa-download"></i></a></td>
                <td style="width:45%;">
                  <div class="form-check form-check-inline">
                  <input class="form-check-input" v-model="selectedEpoch" type="radio" name="epoch" id="epoch-0" :value="selectedSource.epochs[0].name">
                  <label class="form-check-label" for="epoch-0">{{ selectedSource.epochs[0].name}}</label> 
                  </div>
                </td>
                <td style="width:10%;">              <div class="form-check form-check-inline">
                  <button type="button" class="btn btn-link" @click.prevent="toggleEpoch" style="padding:0px;"><i class="bi bi-arrow-left-right" style="font-size:1.3em;"></i></button>
                </div></td>
                <td style="width:45%;">        
                  <div class="form-check form-check-inline">
                  
                    <input class="form-check-input" v-model="selectedEpoch" type="radio" name="epoch" id="epoch-1" :value="selectedSource.epochs[1].name">
                    <label class="form-check-label" for="epoch-1">{{ selectedSource.epochs[1].name}}</label> 
                    
                  </div>
                </td>
              <td style="width:0%;text-align:right;padding-right:10px;padding-left:10px;border-left:1px solid #ccc;"><a title="Download land cover as GeoTIFF"  :href="downloadUrlEnd" target="_blank"  style="color:#ccc;"><i class="fas fa-download"></i></a></td>
            </tr>
            </table>
          </div>
        </div>

        <div style="width:100%;padding:0px;font-size:0.7em;;position:relative;top:-100px;z-index:9999;height:100px;" v-if="selectedSource && (selectedSource['meta']['is_static'] == true) && (this.selectedLandCoverId == null)">
          <div style="width:100%;position:absolute;bottom:10px;padding:0px 10px;">
            <table style="width:100%;text-align:center;border:1px solid #ccc;position:relative;background-color:rgba(250,250,250,0.8);">
              <tr>
                <td style="width:0%;padding-left:10px;" class="text-left"><strong><nobr>Land Cover Map (Static)</nobr></strong></td>
                <td style="width:100%;padding-right:10px;" class="text-right">

                </td>
                <td style="padding:6px 10px;border-left:1px solid #ccc;width:0%;">
                  <a :href="downloadUrlStart" target="_blank" title="Download change map as GeoTIFF" style="color:#ccc;"><i class="fas fa-download"></i></a>
                </td>
              </tr>
            </table>
          </div>
        </div>



        <div style="width:100%;padding:0px;font-size:0.7em;;position:relative;top:-100px;z-index:9999;height:100px;" v-if="selectedSource && (this.selectedLandCoverId != null)">
          <div style="width:100%;position:absolute;bottom:10px;padding:0px 10px;">
            <table style="width:100%;text-align:center;border:1px solid #ccc;position:relative;background-color:rgba(250,250,250,0.8);">
              <tr>
                <td style="width:0%;padding-left:10px;" class="text-left"><strong><nobr>{{ selectedLandCover.name }} (Change map)</nobr></strong></td>
                <td style="width:100%;padding-right:10px;" class="text-right">
                  <label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:5px;"><i class="bi bi-circle-fill" style="color:#ff2a00;font-size:0.9em;"></i> Lost</label>
                  <label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:5px;"><i class="bi bi-circle-fill" style="color:#eeeea8;font-size:0.9em;"></i> Stable</label>
                  <label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:5px;"><i class="bi bi-circle-fill" style="color:#009908;font-size:0.9em;"></i> Gained</label>

                </td>
                <td style="padding:6px 10px;border-left:1px solid #ccc;width:0%;">
                  <a :href="downloadUrlChangeMap" target="_blank" title="Download change map as GeoTIFF" style="color:#ccc;"><i class="fas fa-download"></i></a>
                </td>
              </tr>
            </table>
          </div>
        </div>

        



      </div>


    </div>

    <div class="row no-gutters" v-if="attribution">
      <p class="attribution">{{attribution}}</p>
    </div>

  </div>

</template>

<script>
/* eslint-disable */
import Leaflet from 'leaflet';
import "leaflet/dist/leaflet.css";
import omnivore from "@mapbox/leaflet-omnivore";

import LandCoverAnalysisDetails from '@/components/factsheet/LandCoverAnalysisDetails.vue'

export default {
    name: 'LandCoverAnalysis',
    components: { LandCoverAnalysisDetails },
    props: ['location', 'title', 'description', 'layout', 'attribution', 'factsheet', 'loaded', 'backgrounds'],
    data() {
        return {
            mapBackground: null,
            backgroundLayers: [],
            background: null,
            opacities: [10, 50, 100],
            opacity: 100,

            landcoverCollection: [],
            landcoverSources: [],

            selectedSourceId: null,
            selectedUnits: 'percent',
            selectedEpoch: null,

            availableEpochs: [],

            selectedLandCoverId: null,

            selectedLandCoverEpoch: null,

            preferredSources: ['land_cover_glad', 'land_cover_esa_cci', 'land_cover_cop_gls'],

            availableUnits: [
              {'label': 'percent', 'name': 'percent'},
              {'label': 'hectare', 'name': 'ha'},
              {'label': 'sq. km', 'name': 'sqkm'},
            ]
        }
    },
    created() {

    },
    updated() {

    },
    mounted() {
      // Create the map
      this.map = L.map(this.$refs.map, { 
        'attributionControl': false, 
        'scrollWheelZoom': false }
      );
      //L.control.scale().addTo(this.map);

      this.map.createPane('background');
      this.map.getPane('background').style.pointerEvents = 'none';
      this.map.getPane('background').style.zIndex = 100;

      this.map.createPane('data');      
      this.map.getPane('data').style.zIndex = 200;

      this.map.createPane('change');
      this.map.getPane('change').style.zIndex = 400;

      this.map.createPane('foreground');
      this.map.getPane('foreground').style.pointerEvents = 'none';
      this.map.getPane('foreground').style.zIndex = 900;

      /* This component always uses 'light' map as a background. */
      var url = process.env.VUE_APP_API+"/tools/layer/GeofolioBackgroundLight/v0?z={z}&x={x}&y={y}"
      this.mapBackground = L.tileLayer(url, {
        attribution: '',
        maxZoom: 22,
        pane: 'background'
      }).addTo(this.map);

      /* This component always uses 'light' map as a background. */
      var url = process.env.VUE_APP_API+"/tools/layer/GeofolioLightLabels/v0?z={z}&x={x}&y={y}"
      this.mapBackground = L.tileLayer(url, {
        attribution: '',
        maxZoom: 22,
        pane: 'foreground'
      }).addTo(this.map);

      /* Add two empty data layers... */

      this.landcoverLayer1 = L.tileLayer("", {       
        attribution: '',
        maxZoom: 22,
        pane: 'data'
      }).addTo(this.map);

      this.landcoverLayer2 = L.tileLayer("", {       
        attribution: '',
        maxZoom: 22,
        pane: 'data'
      }).addTo(this.map);

      this.changeLayer = L.tileLayer("", {      
        attribution: '',
        maxZoom: 22,
        pane: 'change'
      }).addTo(this.map);


      this.map.fitBounds(this.location.bounds);

      this.loadMap();
      //this.loadLegend();
    },
    watch: {
      loaded() {
        this.loadMap();
      },
      opacity() {
        this.data.setOpacity(this.opacity / 100);
      },
      selectedSource() {

        if(this.selectedSource != undefined) {
              var dataset_id = this.factsheet.dataset_ids[this.selectedSourceId]

        this.selectedEpoch = this.selectedSource['epochs'][0]['name'];

        var url1 = process.env.VUE_APP_API+'/tools/raster/tile/'+this.factsheet['identifier']+'/'+dataset_id+'/landcover_simplified_'+this.selectedSource['epochs'][0]['name']+'.tif~/tile/{z}/{x}/{y}.png';
        this.landcoverLayer1.setUrl(url1);

        if(this.selectedSource["meta"]["is_static"] != true) {
          var url2 = process.env.VUE_APP_API+'/tools/raster/tile/'+this.factsheet['identifier']+'/'+dataset_id+'/landcover_simplified_'+this.selectedSource['epochs'][1]['name']+'.tif~/tile/{z}/{x}/{y}.png';
          this.landcoverLayer2.setUrl(url2);
        }

        this.selectedLandCoverId = null;    
        }



      },
      selectedEpoch() {
        if(this.selectedSource != undefined) {
          if(this.selectedEpoch == this.selectedSource['epochs'][0]['name']) {
            /* Show the first, hide the second */
            this.landcoverLayer1.setOpacity(1);
            this.landcoverLayer2.setOpacity(0);
          }
          else if(this.selectedEpoch == this.selectedSource['epochs'][1]['name']) {
            /* Hide the first, show the second */
            this.landcoverLayer1.setOpacity(0);
            this.landcoverLayer2.setOpacity(1);
          }
          else {

          }

        }

      },
      selectedLandCoverId() {
        if(this.selectedLandCoverId == null) {
          /* Deselected. Make layer invisible. */
          this.map.getPane('data').style.zIndex = 200;
          this.changeLayer.setOpacity(0);
          this.changeLayer.setUrl("");
        } else {
          /* Set url and show layer */
          var dataset_id = this.factsheet.dataset_ids[this.selectedSourceId]
          var url = process.env.VUE_APP_API+'/tools/raster/tile/'+this.factsheet['identifier']+'/'+dataset_id+'/change_'+this.selectedLandCoverId+'.tif~/tile/{z}/{x}/{y}.png';
          this.changeLayer.setUrl(url)
          this.map.getPane('data').style.zIndex = 0;
          this.changeLayer.setOpacity(1);
        }
      },
    },
    methods: {
      barStyle(t, item) {
        if(t == 'loss') {
          return "background-color:#ff2a00;width:"+item["loss_perc"]+"%;"
        }
        if(t == 'stable') {
          return "background-color:#eeeea8;width:"+item["stable_perc"]+"%;"
        }
        if(t == 'gain') {
          return "background-color:#009908;width:"+item["gain_perc"]+"%;"
        }
      },
      toggleLandCover(id) {
        if( (this.selectedLandCoverId == id) || (this.selectedSource['meta']['is_static'] == true)) {
          this.selectedLandCoverId = null;
        } else {
          this.selectedLandCoverId = id;
        }
      },
      toggleEpoch() {
        if(this.selectedSource != undefined) {
          if(this.selectedEpoch == this.selectedSource['epochs'][0]['name']) {            
            this.selectedEpoch = this.selectedSource['epochs'][1]['name'];
          }
          else if(this.selectedEpoch == this.selectedSource['epochs'][1]['name']) {
            this.selectedEpoch = this.selectedSource['epochs'][0]['name'];
          }
          else {
            return;
          }
        } else {
          console.log("Skip due to no source.")
        }
      },
      loadMap() {
        /* Look for any land cover change analysis data in our results. */
        _.forEach(this.factsheet.data, (data) => {
          if((data != null) && data.hasOwnProperty("land_cover_analysis") && (data["land_cover_analysis"] != null) && (data["land_cover_analysis"] != {})) {

            _.forEach(data["land_cover_analysis"]["analysis"], (item) => {

              var tot = item["gain"] + item["stable"] + item["loss"]

              item["gain_perc"] = 100*(item["gain"] / tot);
              item["stable_perc"] = 100*(item["stable"] / tot);
              item["loss_perc"] = 100*(item["loss"] / tot);

              this.landcoverCollection.push(item);
            });
            data["land_cover_analysis"]["source"]["meta"] = data["land_cover_analysis"]["meta"]
            this.landcoverSources.push(data["land_cover_analysis"]["source"])
          }
        });

        this.selectedSourceId = 'land_cover_glad'
      },
      initMap() {
        this.updateMap()
      },
      updateMap() {

      },
      landcoverStyle(result) {
        return "position:inline;display:block;width:40px;height:30px;margin-right:4px;margin-top:2px;border-radius:0px;background-color:"+result["color"];
      },
      landcoverProgressStyle(result) {
        var width = 100*(result['stable'] / 1009068417 / 1.4)
        var color = '#ccc;'
        return "width:"+width+"%;"
      },
      landcoverUnits(result) {
        /* Display the land cover class with the correct representation */
        if(result['static'] != undefined) {
          var static_ = result['static']
          var total = this.selectedSource['meta']['total_area']
          if (this.selectedUnits == 'ha') {
            return '<strong>'+(static_/10000).toFixed(0) + 'ha</strong>';
          }
          if (this.selectedUnits == 'sqkm') {
            return '<strong>'+(static_/1000000).toFixed(1) + 'km²</strong>';
          }
          if (this.selectedUnits == 'percent') {
            return '<strong>'+(100 * (static_/total)).toFixed(1) + '%</strong>';
          }
          return '?'
        } else {
          var current = result['stable'] + result['gain']
          var previous = result['stable'] + result['loss']

          var change = result['gain'] - result['loss']
          var total = this.selectedSource['meta']['total_area']
          if (this.selectedUnits == 'ha') {
            return '<strong>'+(current/10000).toFixed(0) + 'ha</strong>'+this.changeFormatter(change/10000,0,'ha')
          }
          if (this.selectedUnits == 'sqkm') {
            return '<strong>'+(current/1000000).toFixed(1) + 'km²</strong>'+this.changeFormatter(change/1000000,1,'km²')
          }
          if (this.selectedUnits == 'percent') {
            return '<strong>'+(100 * (current/total)).toFixed(1)+'%</strong>'+this.changeFormatter(100*((current/total) - (previous/total)),1, '%')
          }
          return '?'
        }
      },
      changeFormatter(value, decimals, units) {
        if(value > 0) {
          return '<span style="color:rgb(21, 176, 26)"><i class="bi bi-arrow-up-short"></i>'+Math.abs(value).toFixed(decimals)+units+'</span>'
        }
        else if (value < 0) {
          return '<span style="color:rgb(229, 0, 0)"><i class="bi bi-arrow-down-short"></i>'+Math.abs(value).toFixed(decimals)+units+'</span>'
        }
        else {
          return ''
        }
      }
    },
    filters: {

    },
    computed: {
      downloadUrlStart() {
        if(this.selectedSource != undefined) {
          var dataset_id = this.factsheet.dataset_ids[this.selectedSourceId];
          var url = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet['identifier']+'/data/'+dataset_id+'/landcover_simplified_'+this.selectedSource['epochs'][0]['name']+'.tif';
          return url
        }
        return "#";
      },
      downloadUrlEnd() {
        if(this.selectedSource != undefined) {
          var dataset_id = this.factsheet.dataset_ids[this.selectedSourceId];
          var url = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet['identifier']+'/data/'+dataset_id+'/landcover_simplified_'+this.selectedSource['epochs'][1]['name']+'.tif';
          return url
        }
        return "#";
      },
      downloadUrlChangeMap() {
        if( (this.selectedSource != undefined) && (this.selectedLandCoverId)) {
          var dataset_id = this.factsheet.dataset_ids[this.selectedSourceId];
          var url = process.env.VUE_APP_API+'/data/factsheet/'+this.factsheet['identifier']+'/data/'+dataset_id+'/change_'+this.selectedLandCoverId+'.tif';
          return url
        }
        return "#";
      },
      enabledSources() {
        return this.landcoverSources;
      },
      selectedSource() {
        return _.filter(this.enabledSources, (item) => { 
          return item["id"] == this.selectedSourceId;
        })[0];
      },
      selectedLandCover() {
        return _.filter(this.results, (item) => { 
          return ((item["source"] == this.selectedSourceId) && (item["id"] == this.selectedLandCoverId))
        })[0];
      },
      results() {
        return this.resultsSorted;
        /*
        return _.filter(this.resultsSorted, (item) => { 
          return ((item["stable"] != null) && (item["stable"] > 0)) || 
                 ((item["static"] != null) && (item["static"] > 0)) || 
                 ((item["static"] != null) && (item["gain"] > 0)) ||
                 ((item["static"] != null) && (item["loss"] > 0));
        });
        */
      },
      resultsSorted() {
        if(this.selectedSource && this.selectedSource["meta"]["is_static"]) {
          return _.sortBy(this.resultsUnsorted, [function(o) { return o['static']; }]).reverse();
        } else {
          return _.sortBy(this.resultsUnsorted, ({ stable }) => stable || '', ['desc',]).reverse();
        }
        
      },
      resultsLookup() {
        /* Return an object that can easily be used as a lookup table to look up class details like name and color. */
        var resultsLookup = {};
        _.forEach(this.results, (result) => {
          resultsLookup[result.id] = result;
        });
        return resultsLookup;
      },
      resultsUnsorted() {
        return _.filter(this.landcoverCollection, (item) => { 
          return item["source"] == this.selectedSourceId;
        });
      },
      numResults() {
        return this.results.length;
      },
      resultItemStyle() {
        if (this.selectedSource['meta']['is_static'] == true) {
          return "pointer-events: none;cursor: default;text-decoration:none;color:#666;"
        } else {
          return ""
        }
      }
    }
}
</script>
<style>
div.label-icon {
  text-align:center;
  pointer-events: none;
}
div.label-icon span {
  font-size:0.75em;
  background-color:rgba(255,255,255,0);
  border:0px solid #ddd;
  padding:1px 3px;
  font-weight:bold;
  color:#000;
  border-radius:3px;
  display:inline-block;
  pointer-events: none;
}
</style>

<style scoped>

div.landcovermap {
  margin:10px 0px 10px 0px;
}
h4 {
  margin:0px;
  padding:8px;
  padding-left:10px;
  font-size:0.9em;
  width:100%;
  color:#444;
}
h5 {
  font-size:0.7em;
  color:#666;
  font-weight:600;
  padding:5px 0px 5px 0px;
  margin:0px;

}
p {
  margin:0px;
  font-size:0.6em;
  color:#222;
}
p.attribution {
  font-size:0.5em;
  padding:0px 6px 3px 6px;
  color:#888;
}
div.cmd, div.row {
  background-color:#f5f5f5;
}
a.btn-command:focus, a.btn-command:active {
  outline:none !important;
  box-shadow:none;
} 
a.btn-command {
  background-color:#f5f5f5;
  color:#999;
}
a.btn-command:hover {
  background-color:#eeeeee;
  color:#777;
}
a.btn-command i {
  font-size:0.8em;
}
div.legend-wrapper {
  padding:7px;
}


ul.cmd-group {
  display:inline;
  font-size:0.65em;
  border:1px solid #bbb;
  border-radius:2px;
  padding:0;
  margin:0;
  margin-left:5px;
  background-color:#fff;
}
ul.cmd-group li {
  display:inline-block;
  margin:0px;
  padding:4px 2px 4px 2px;
}
ul.cmd-group li a.active {
  color:rgb(21, 176, 26);
}
ul.cmd-group li.title {
  padding-left:0px;
}
ul.cmd-group li.title a {
  background-color:#f5f5f5;
  border-right:1px solid #ccc;
  padding-right:4px;
  padding-left:3px;
  color:#777;
}
ul.cmd-group li a {
  padding-left:2px;
  padding-right:2px;
  color:#bbb;
}
ul.cmd-group li a svg {
  color:#aaa;
}
ul.cmd-group a.icon {
  font-size:0.9em;
}
ul.cmd-group a:hover {
  color:#777;
}

div.layer-selection {
  font-size:1em;
}
div.layer-selection a.btn-layer {
  color:#007bff;
}
div.layer-selection a.active {
  background-color:#fff;
}
div.layer-selection a.btn-layer:hover {
  color:#0056b3;
}

div.layer-commands {
  font-size:1em;
}
div.layer-commands a.btn-layer {
  color:#aaa;
}
div.layer-commands a.btn-layer:hover {
  color:#0056b3;
}
.btn:focus,.btn:active {
   outline: none !important;
   box-shadow: none;
}

div.legend-description p {
  margin-bottom:5px;
}


form#indicators,
form#indicators-disabled,
form#indicators-analysisLevel {
  font-size:0.75em;
}
form#indicators .form-check-input:disabled ~ .form-check-label,
form#indicators-analysisLevel .form-check-input:disabled ~ .form-check-label {
  color:#aaa ;
}

ul#result-list {
  list-style:none;
  margin:0px;
  padding:0px;
}
ul#result-list li {
  padding:0px;
  margin:0px;
  margin-bottom:5px;
  margin-left:5px;
}
ul#result-list li:last-child {
  margin-bottom:0px;
}
div.result-list-box {
  line-height:0.95em;
}
div.result-list-box a {
  display:block;
  border: 1px solid #ccc;
  background-color:#f9f9f9;
  color:#333;
}
div.result-list-box a:hover {
  border: 1px solid #aaa;
  background-color:#fff;
}
div.result-list-box a:hover h6 {
  color: #007bff;
}
div.result-list-box span.sub {
  font-size:0.9em;
}
table.mini h6 {
  margin:0px;
  padding:0px;
  font-size:1.1em;
  font-weight:bold;
  color:#c46802;
}
table.mini {
  width:100%;
  font-size:0.7em;
  table-layout:fixed;
}
table.mini td, table.mini th {
  line-height:1.4em;
}
table.mini, table.mini tr, table.mini td {
  margin:0px;
  padding:0px;
}
table.mini tr.small {
  font-size:0.9em;
}
table.mini td, table.mini th {
  padding-left:3px;
  padding-right:3px;
}
table.mini td {
  text-align:center;
  border-left:1px dotted #888;
}
table.mini th {
  font-weight:bold;
  text-align:center;
  border-bottom:1px dotted #888;
  border-left:1px dotted #888;
  padding-left:3px;
  padding-right:3px;
}
table.mini td:first-child, 
table.mini th:first-child {  
  text-align:left;
  padding:0px;
  width:100%;
  border-left:0px;
}
table.mini th.std-w, table.mini td.std-w {
  width:58px !important;
}
table.mini tr.section {
  border-top:1px dotted #888;
}
table.mini tr.section th {
  border:none;
  font-weight:bold;
  padding:0px;
  padding-top:4px;
  font-size:0.95em;
  color:#444;
}
div.sort-options {
  border-bottom:0px solid #ccc;
  margin-bottom:5px;
  font-size:0.6em;
  margin:0px 5px 0px 5px;
  padding:5px;
  padding-top:0px;
  font-weight:bold;
  color:#666;
}

a.sort-option {
  font-weight:normal;
}
li.result-item a {
  padding:0px; 
  font-size:0.9em;
  display:block;
  border: 1px solid #ccc;
  background-color:#f5f5f5s;
  margin-right:10px;
  padding:6px;
  padding:0px;
  padding:6px;
  background-color:#fff;
}
li.result-item a.selected i.bi-toggle-off {
  display:none;
}
li.result-item a:not(.selected) i.bi-toggle-on {
  display:none;
}
li.result-item div.wrapperActive {
  background-color:rgba(255,255,0,0.5);
  //cursor:pointer;
}
li.result-item a:hover {
  background-color:rgba(0, 123, 255, 0.03) !important;
}


a.sort-by {
  //color:#666;
}
a.sort-by-selected {
  color:#000;
  text-decoration:underline; 
}
.column-wrapper {
  column-count: 3;
}


</style>